<template>
    <div id="data-list-list-view">
        <div class="flex search-wrap padTop20 btn-box">
          <div class="flex">
            <!-- <v-select v-model="categoryId" :options="options" :reduce="opt => opt.id"
                          placeholder="请选择分类" class="select-wrap">
                <div slot="no-options">暂无选项</div>
            </v-select>     -->
             <el-select
                v-model="categoryId"
                multiple
                collapse-tags
                class="customerType"
                placeholder="商品分类">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
                 <div slot="no-options">暂无选项</div>
              </el-select>
            <v-select v-model="sellType" :options="sellTypeList" :reduce="opt => opt.id"
                       class="marLeft16" placeholder="请选择上架模式">
              <div slot="no-options">暂无选项</div>
            </v-select>
            <v-select v-model="status" :options="sellStatusList" :reduce="opt => opt.id"
                      class="marLeft16" placeholder="请选择上架状态">
              <div slot="no-options">暂无选项</div>
            </v-select>
            <gc-cmp-vs-input v-model="filterText" class="filterInput marLeft16"
                          placeholder="请输入商品名称/编码/69码"/>
            <vs-button type="filled" size="small"
                      @click.prevent="getTableData(1)"
                      class="marLeft16">查询</vs-button>
          </div>
          <div class="btn-content flex">
            <div class="download-wrap pointer" @click.stop="download()">
              <vs-button v-if="filtering('skuSell:loadSkuSellConfigDataExport')" class="down-btn" type="border" icon-pack="feather" icon="icon-download">导出</vs-button>
            </div>
            <div class="download-wrap marLeft16 pointer" @click.stop="exportData(tr)">
              <vs-button v-if="filtering('skuSell:exportDispersionSkuConfig')" class="down-btn" type="border" icon-pack="feather" icon="icon-download">分开上架导出</vs-button>
            </div>
            <vs-button v-if="filtering('skuSell:importSkuSellConfig')" class="down-btn marLeft16" type="border" icon-pack="feather" icon="icon-share" @click="showImportDialog= true">批量导入</vs-button>
          </div>
        </div>
        <!-- 商品价格 -->
        <div id="priceTable" class="con-tablex vs-table--content">
          <div class="vs-con-tbody vs-table--tbody ">
            <table :data="tableData" ref="table" class="vs-table vs-table--tbody-table">
              <thead ref="thead" class="vs-table--thead">
                <vs-th style="width:80px">序号</vs-th>
                <vs-th style="width:120px">商品分类</vs-th>
                <vs-th style="width:200px">商品名称</vs-th>
                <vs-th style="width:100px">商品编码</vs-th>
                <vs-th style="width:100px">69码</vs-th>
                <vs-th style="width:100px">实际库存</vs-th>
                <vs-th style="width:100px">上架模式</vs-th>
                <vs-th style="width:100px">总上架数</vs-th>
                <vs-th style="width:110px">上架客户数</vs-th>
                <vs-th style="width:200px">最近上架时间</vs-th>
                <vs-th style="width:100px">上架状态</vs-th>
                <vs-th style="width:120px" class="fixed-table-column th-back">操作</vs-th>
              </thead>
              <template>
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in tableData">
                    <vs-td>{{ indextr + 1 }}</vs-td>
                    <vs-td>{{ tr['goodsCategoryName'] }}</vs-td>
                    <vs-td>{{ tr['goodsName'] }}</vs-td>
                    <vs-td>{{ tr['skuCode'] }}</vs-td>
                    <vs-td>{{ tr['barCode'] }}</vs-td>
                    <vs-td>{{ tr['relStock'] }}</vs-td>
                    <vs-td>{{ tr['sellTypeDesc'] }}</vs-td>
                    <vs-td>{{ tr['allSellNum'] }}</vs-td>
                    <vs-td>{{ tr['allStoreNum'] }}</vs-td>
                    <vs-td>{{ tr['lastModifyTime'] }}</vs-td>
                    <vs-td v-if="filtering('skuSell:updateSkuSellConfig')">
                      <vs-switch v-model="tr.stats" @input="changeStatus(tr.id, tr.stats)"/>
                    </vs-td>
                    <vs-td class="fixed-table-column white">
                       <vs-button color="primary" type="flat" class="btn" v-if="filtering('skuSell:loadConfigDetail')" @click.stop="openEditPop(tr)">
                        {{tr.stats ? '编辑' : '查看'}}
                      </vs-button>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </table>
          </div>
          <div v-if="tableData.length == 0" class="vs-table--not-data">
            <img src="@/assets/images/commodity-sys/no-data.png" />
            <div class="nodata-text">暂无数据</div>
          </div>
          <!-- <div class="con-pagination-table vs-table--pagination">
            <gc-vs-pagination :total="pager.total" v-model="pager.page" :max="7"
                           :goto="true" class="marTop16"></gc-vs-pagination>
          </div>       -->
          <gc-vs-pagination
            :pager="pager"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
            ></gc-vs-pagination>
        </div>
    <vs-popup
      id="import-dialog"
      @accept="importFund()"
      title="商品批量导入"
      :active.sync="showImportDialog">
      <div class="import-wrap con-exemple-prompt">
        <div class="import-label">导入文件</div>
        <div class="right-part">
          <el-upload
            ref="upload"
            class="upload-demo"
            action = '/data-dist/api/dist/sku/sell/config/importSkuSellConfig'
            :accept="accept"
            :show-file-list = "false"
            :limit="1000"
            :on-success="uploadSuccess"
            :headers= "tokenHeader">
            <vs-button color="primary" type="filled" class="browse-btn">浏览</vs-button>
                </el-upload>
          <div class="downLoadText pointer" @click="downloadTemplate()">下载文件模板</div>
        </div>
      </div>
      <vs-popup title="导入完成" :active.sync="errorTip" v-if="JSON.stringify(errorResult) !== '{}'">
        <div v-if="errorResult.errorSkuCode.length || errorResult.errorClientId.length">部分失败的导入详情如下</div>
        <template v-if="errorResult.errorSkuCode.length || errorResult.errorNum.length ">
          <div>导入错误的商品:</div>
          <div v-for="(item,index) in errorResult.errorSkuCode" :key="index">
            {{item}}
          </div>
          <div v-for="(item,index) in errorResult.errorNum" :key="index">
            {{item}}
          </div>
        </template>
        <template v-if="errorResult.errorClientId.length">
          <div>导入错误的客户:</div>
          <div v-for="(item,index) in errorResult.errorClientId" :key="index">
            {{item}}
          </div>
        </template>
      </vs-popup>
    </vs-popup>
  </div>
</template>

<script>
  import GcCmpVsTable from "@/group-cloud/components/vsTable";
  import GcCmpVsInput from "@/group-cloud/components/vsInput";
  import { OrderApi } from '@/modules/server-api/commodity-sys/order';
  import {
    OnShelvesApi, Shelf_Mode_Types_Opts
  } from "@/modules/server-api/commodity-sys/on-shelves";
  import { downloadFileTemplate, downloadExcel } from "@/utils/downloadExcel.js";
  import { $busErrorCode, getThreeCategory,uploadHeader } from "@/modules/commodity-sys/common.js";
  import {CommodityCategoryApi} from "@/modules/server-api/commodity-sys/category-manage";
  export default {
    data(){
        return{
          errorTip: false,
          errorResult: {},
          filterText:"",
          categoryId: "", //分类
          allCategoryIds : [],
          options:[],
          sellType: '',
          sellTypeList : Shelf_Mode_Types_Opts,
          status: '',
          sellStatusList: [
            {id:0, label: '未上架'},
            {id:1, label: '已上架'}
          ],
          tableData:[],
          gradeTableData:[],
          pager: {
            page: 1,
            size: 20,
            total: 0
          },
          currSkuInfo : {}, //当前编辑的商品
          showImportDialog: false,
          tokenHeader: uploadHeader,
          accept:'.xlsx',

        }
    },
    mounted(){
      //获取分类
      this.getCategoryOptions();

    },
    methods:{
      //查询商品价格:分类必须要有
      async getTableData(page){
        this.pager.page = page || this.pager.page;

        let categoryParam = [];
        if(!this.categoryId || this.categoryId == ''){
          categoryParam = this.allCategoryIds;
        }else{
          this.categoryId.map(item=>{
            categoryParam.push(item)
          })
          // categoryParam.push(this.categoryId);
        }

        if(categoryParam.length > 0){
          this.$vs.loading();
          this.tableData = [];
          let resp = await OnShelvesApi.getSkuSellList({
              "pageNum": this.pager.page,
              "pageSize": this.pager.size,
              "fuzzyKeyword": this.filterText,
              "categoryId": categoryParam,
              status: this.status,
              sellType: this.sellType

          });
          if(resp.succ == 0 || resp.code == $busErrorCode){
            this.$vs.loading.close();
            this.$notifyError(resp.error);
          }else{
            let resData = resp.result.list;
            if(resData){
              resData.map(item => {
                //获取上架模式
                let desc = this.sellTypeList.filter(sell => sell.id == item.sellType);
                item.sellTypeDesc = desc.length == 0 ? '' : desc[0].label;
                this.tableData.push(item);
              })
            }
            //更新分页参数
            //this.pager.total = Math.ceil(resp.result.totalCount / this.pager.size);
            this.pager.total = resp.result.totalCount;
            this.$vs.loading.close();
          }
        }
      },
      //获取分类
      async getCategoryOptions(){
          //获取分类数据
          let resCategoryList = await CommodityCategoryApi.getCategoryList({});
          let resList = resCategoryList.result;
          if(resList){
              //获取三级分类
              let finalList = [];
              resList.map((item) =>{
                  let child = getThreeCategory(item);
                  if(child && child.length > 0){
                      child.map((item) => finalList.push(item));
                  }
              });
              this.allCategoryIds = [];
              finalList && finalList.map((item) =>{
                  let obj ={};
                  obj.id = item.id;
                  obj.label = item.categoryName;
                  this.allCategoryIds.push(item.id);
                  this.options.push(obj);
              });
              //加载数据
              this.getTableData();
          }
      },
      //修改商品上下架
      changeStatus(id, status) {
        if(!id || id==''){
          this.$notifyError("修改失败：当前编辑行没有唯一标识");
        }else{
          //编辑
          let finalStatus = status ? 1 : 0;
          OnShelvesApi.updateSkuStatus({
            skuSellConfigId: id,
            stats: finalStatus
          }).then(res => {
            if(res.succ == 1 && res.code != $busErrorCode) {
              this.$notifySuccess('更新成功');
            } else {
              this.$notifyError(res.error || '更新失败');
            }
            //this.getTableData()
          });
        }
      },
      //编辑弹窗
      openEditPop(row){
        this.$router.push({
          path: `/modules/commodity/sys/on-shelves/edit`,
          query: row
        }).catch(() => {})
      },
      //确定导入
      importFund(){
        this.$notifySuccess('确定导入');
      },
       //导入文件后回调函数
      uploadSuccess(response, file, fileList){
        console.log(response)
        if(response.succ == 1 && response.code != $busErrorCode){
          this.showImportDialog = false;
          if(response.result.errorSkuCode.length || response.result.errorClientId.length || response.result.errorNum.length) {
            this.errorTip = true
            this.errorResult = response.result
          //  this.$notifyInfo(`错误商品编码${response.result.errorSkuCode.join(',')}, 错误的客户编码${response.result.errorClientId.join(',')}`);
          } else {
            this.showImportDialog = false;
            this.$notifySuccess('导入成功');
            //加载数据
              this.getTableData();
          }
        }else{
          this.showImportDialog = false;
          this.$notifyError(response.error || '导入数据格式错误,请修改后重新上传');
        }
      },
      //下载文件模板
      downloadTemplate(){
        downloadFileTemplate('/data-dist/api/dist/down/template/sku_sell_config', '商品上架模板.xlsx');
      },
      async download() {
        //组装下载参数
        let categoryParam = [];
        console.log(this.categoryId);
        if(!this.categoryId || this.categoryId == ''){
          categoryParam = this.allCategoryIds;
        }else if(this.categoryId.length >1){
          categoryParam = this.categoryId;
        }
        else{
          categoryParam.push(this.categoryId[0]);
        }
        if(categoryParam.length > 0){
          let param = {
              fuzzyKeyword: this.filterText,
              categoryId: categoryParam,
              status: this.status,
              sellType: this.sellType
          };
          let url = '/data-dist/api/dist/sku/sell/config/loadSkuSellConfigDataExport';
          let fileName = '商品上架导出列表.xlsx';
          // downloadExcel(url, param, fileName);
          const res = await OrderApi.goodsOnShelfExport(param)
          if(res.code=='0'){
            this.$notifySuccess(res.result)
          }else{
            this.$notifyError(res.error);
          }
        }
      },
     async exportData() {
        const res = await OrderApi.goodsSplitOnShelfExport()
        if(res.code=='0'){
          this.$notifySuccess(res.result)
        }else{
          this.$notifyError(res.error);
        }
        // downloadFileTemplate('/data-dist/api/dist/sku/sell/config/exportDispersionSkuConfig', '分开上架导出列表.xlsx');
      },
      //更改每页条数
      handleSizeChange(val){
        this.pager.size = val;
        this.getTableData();
      },
      handleCurrentChange(val){
        this.pager.page = val;
        this.getTableData();
      }
    },
    components: {
      GcCmpVsTable, GcCmpVsInput
    },
    watch:{
      //分页
      // "pager.page"(){
      //   this.getTableData();
      // }
    }
  }
</script>

<style lang="scss" scoped>
 @import '@/modules/commodity-sys/commodity.scss';
 .search-wrap{
   margin-top: 20px;
   margin-bottom: 20px;
   @include flex-mixin(row, center, space-between);
  .down-btn {
    padding: 8px 10px !important;
  }
 }
//  #priceTable /deep/ .vs-con-tbody {
//     max-width: 1300px;
//     overflow: auto;
//   }

.v-select {
  width:130px
}
.filterInput {
  width: 200px;
}
.btn-box {
  position: relative;
}
.btn-content  {
  position: absolute;
  top: 80px;
  right: 10px;
}
#priceTable {
  margin-top: 80px;
}
.customerType   /deep/ .el-input__inner {
    border: 1px solid rgba(60, 60, 60, 0.26) !important;
    height: 38px;
  }
  .customerType   /deep/ input::-webkit-input-placeholder {
      color: rgba(0, 0, 0, 0.4);
    /* 字体大小直接写样式即可 */
      font-size: 12px;
  }
</style>
